import { isString } from 'lodash';
import ESAPI from 'node-esapi';

const replaceAll = (str, find, replace) => str.replace(new RegExp(find, 'g'), replace);

const convertSpecialSymbols = (value) => {
  // Ampersand must be first to not step on the other conversions
  let converted = replaceAll(value, '&', '&amp;');
  converted = replaceAll(converted, '<', '&lt;');
  converted = replaceAll(converted, '>', '&gt;');
  converted = replaceAll(converted, "'", '&#x27;');
  return converted;
};

const restoreSpecialSymbols = (value) => {
  let converted = replaceAll(value, '&#x24;', '$');
  converted = replaceAll(converted, '&#x28;', '(');
  converted = replaceAll(converted, '&#x29;', ')');
  converted = replaceAll(converted, '&#x2f;', '/');
  converted = replaceAll(converted, '&#x40;', '@');
  converted = replaceAll(converted, '&#x21;', '!');
  converted = replaceAll(converted, '&#x3b;', ';');
  converted = replaceAll(converted, '&#x25;', '%');
  converted = replaceAll(converted, '&#x23;', '#');
  converted = replaceAll(converted, '&#x2a;', '*');
  converted = replaceAll(converted, '&#x2b;', '+');
  converted = replaceAll(converted, '&#x3d;', '=');
  converted = replaceAll(converted, '&#x3a;', ':');
  converted = replaceAll(converted, '&quot;', '"');
  converted = replaceAll(converted, '&#x3f;', '?');
  converted = replaceAll(converted, '&#x7c;', '|');
  converted = replaceAll(converted, '&#x5b;', '[');
  converted = replaceAll(converted, '&#x5d;', ']');
  converted = replaceAll(converted, '&rsquo;', '’');
  converted = replaceAll(converted, '&lsquo;', '‘');
  return converted;
};

const xssValidate = (value) => {
  // instant fail on string with '<' and then '>'
  const regex = /.*<.*>.*/;

  const match = regex.exec(value);
  if (match != null) {
    return 'FAIL';
  }

  if (!isString(value)) {
    return null;
  }

  // instant fail with string javascript
  if (value.toLowerCase().indexOf('script:') !== -1) {
    return 'FAIL';
  }

  if (ESAPI) {
    const oflows = convertSpecialSymbols(value);
    const owasp = ESAPI.encoder().encodeForHTMLAttribute(value);
    const owaspFinal = restoreSpecialSymbols(owasp);

    // if nothing was converted and we don't have any JavaScript then return safely
    if (owaspFinal === value) {
      return 'PASS';
    }

    if (owaspFinal && owaspFinal !== oflows) {
      return 'FAIL';
    }
  }

  return null;
};

function xssValidator({ input, msgs }) {
  // this encodes everything (a little different from server-side xssValidation)
  const result = xssValidate(input);
  if (result === 'FAIL') {
    if (msgs && msgs.msg) {
      return msgs.msg;
    }
    return 'Invalid input: Html or JavaScript is not allowed';
  }

  return null;
}

export default xssValidator;
